import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-selected",
  "use": "icon-selected-usage",
  "viewBox": "0 0 54 54",
  "content": "<symbol viewBox=\"0 0 54 54\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-selected\">\n  <path d=\"M27 54C12.0883 54 0 41.9117 0 27C0 12.0883 12.0883 0 27 0C41.9117 0 54 12.0883 54 27C54 41.9117 41.9117 54 27 54Z\" fill=\"#E90F23\" />\n  <path d=\"M40.4114 17.0087L42.8196 19.6128L23.382 38.5341L11.8652 26.354L14.3081 23.8925L23.5148 31.341L40.4114 17.0087Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol